import { turboLoad } from 'src/v3/utils';
import panoramaListener from 'src/v3/car_listing/panorama';
import initCarListingGlightBox from 'src/v3/car_listing/glightbox';

turboLoad(panoramaListener);
turboLoad(initCarListingGlightBox);
